import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_INBOX_MESSAGES_UNREAD_COUNT_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type { GetInboxMessageUnreadCountResult } from '../types/getInboxMessageUnreadCount.types';

export const INBOX_MESSAGES_UNREAD_COUNT_TAGS = 'getInboxMessageUnreadCount';

export const getInboxMessageUnreadCount = (builder: BuilderType) =>
  builder.query<GetInboxMessageUnreadCountResult, void>({
    providesTags: [INBOX_MESSAGES_UNREAD_COUNT_TAGS],
    query: () => ({
      method: 'POST',
      url: GET_INBOX_MESSAGES_UNREAD_COUNT_URL,
    }),
    transformResponse: (response: GenericApiResponse<GetInboxMessageUnreadCountResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }

      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
